// extracted by mini-css-extract-plugin
export var isActive = "styles-module--isActive--46e6f";
export var snipcartCounter = "styles-module--snipcartCounter--96c5e";